<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t("Detalhes do Atendimento") }}
    </h1>
    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div class="row">
      <div class="col-md-12">
        <print-content>
          <table
            class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
          >
            <tbody>
              <tr>
                <td>
                  ID: <strong>{{ item.id }}</strong>
                </td>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  <span class="small">
                    ATENDIMENTO:
                    <strong v-if="item.data_cadastro">{{
                      item.data_cadastro_formatado
                    }}</strong>
                    <br />
                    CADASTRADO:
                    <strong>{{ item.cadastrado }}</strong>
                  </span>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ item.atualizado }}</strong>
                </td>
              </tr>
              <tr v-if="item.familia_id">
                <td colspan="4">
                  USUÁRIO(S) ATENDIDO(S):
                  <strong
                    class="mr-2"
                    v-for="(pessoa, index) in item.pessoas_objetos"
                    :key="pessoa.id"
                  >
                    <span v-if="pessoa.nome_social">{{
                      pessoa.nome_social
                    }}</span>
                    <span v-else> {{ pessoa.nome_completo }} </span>
                    <span v-if="index < item.pessoas_objetos.length - 1"
                      >,</span
                    >
                  </strong>
                  <small
                    class="text-muted"
                    v-if="
                      item.familia_id.rf_situacao_rua != null &&
                      item.familia_id.rf_situacao_rua.status == 1
                    "
                    ><br />RF registrado em Situação de Rua no Sistema</small
                  >
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  TÉCNICO RESPONSÁVEL: <b v-if="item.responsavel">{{
                    item.responsavel.name
                  }}</b>
                </td>
                <td colspan="2">
                  UNIDADE:
                  <b v-if="item.unidade">{{ item.unidade.nome }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  TÉCNICO AUTOR:
                  <b>{{ item.autor }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  OUTRO(S) TÉCNICO(S):
                  <strong
                    class="mr-2"
                    v-for="(tecnico, index) in item.outros_tecnicos"
                    :key="index"
                  >
                    {{ tecnico.nome }}
                    <span v-if="index < item.outros_tecnicos.length - 1"
                      >,</span
                    >
                  </strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  TIPO DE ATENDIMENTO: <b>{{ item.tipo }}</b>
                </td>
                <td>
                  STATUS:
                  <strong v-html="item.status_nome"></strong>
                </td>
                <td>
                  SIGILO:
                  <b>{{ item.privado == "1" ? "Sim" : "Não" }}</b>
                </td>
              </tr>
              <tr v-if="item.denuncias && item.denuncias.length > 0">
                <td colspan="4">
                  DENÚNCIAS:
                  <b
                    class="mr-2"
                    v-for="(denuncia, index) in item.denuncias"
                    :key="index"
                  >
                    <router-link
                      v-if="denuncia"
                      class="btn btn-sm btn-light py-0 px-1 my-1"
                      :to="`/dashboard/denuncias/edit/${denuncia.id}`"
                    >
                      {{ denuncia.protocolo }}
                    </router-link>
                  </b>
                </td>
              </tr>
              <tr>
                <td :colspan="item.outra_unidade ? '' : '2'">
                  SERVIÇO:
                  <strong
                    v-html="verificarValueArray(item.tipo_servico_id, servicos)"
                  ></strong>
                </td>
                <td :colspan="item.outra_unidade ? '' : '2'">
                  LOCAL DE ATENDIMENTO:
                  <strong
                    v-html="
                      verificarValueArray(
                        item.local,
                        $root.arrays.atendimento_local
                      )
                    "
                  ></strong>
                </td>
              </tr>
              <tr v-if="item.tipo == 'ABORDAGEM SOCIAL'">
                <td :colspan="item.outra_situacao_abordagem_social ? '2' : '4'">
                  SITUAÇÕES IDENTIFICADAS NA ABORDAGEM SOCIAL:<br />
                  <strong
                    v-html="item.situacao_abordagem_social_nomes"
                  ></strong>
                </td>
                <td v-if="item.outra_situacao_abordagem_social" colspan="2">
                  OUTRAS SITUAÇÕES IDENTIFICADAS:<br />
                  <strong
                    v-html="item.outra_situacao_abordagem_social"
                  ></strong>
                </td>
              </tr>
              <tr v-if="item.data_prevista != ''">
                <td colspan="2">
                  DATA DO AGENDAMENTO:
                  <strong>{{ item.data_prevista_formatado }}</strong>
                </td>
                <td colspan="2">
                  HORA DO AGENDAMENTO:
                  <strong>{{ item.hora_prevista_formatado }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  DESCRIÇÃO SUMÁRIA DO ATENDIMENTO:
                  <div v-html="item.descricao_sumaria"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <print-footer
            v-if="item.responsavel.tecnico.assinatura_digital"
            :email="email"
            :wpp="wpp"
            :tecnico="item.responsavel.tecnico"
            class="mt-0"
            :assinatura="item.responsavel.tecnico.assinatura_digital"
          />
          <span
            class="mr-2"
            v-for="(tecnico, index) in item.outros_tecnicos"
            :key="index"
            v-if="outrasAssinaturas"
          >
            <print-footer
              :tecnico="tecnico"
              class="mt-0"
              :assinatura="tecnico.assinatura_digital"
            />
          </span>

          <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

          <div class="row pt-4 px-0 d-flex justify-content-end no-print">
            <div class="col-auto px-2 text-right">
              <router-link
                :to="`/dashboard/atendimentos/${item.familia}`"
                class="btn btn-default"
              >
                <i class="mdi mdi-arrow-left" />
              </router-link>
              <a class="btn btn-sm py-1 btn-primary" @click="print()">
                <i class="mdi mdi-printer mdi-18px" />
              </a>
              <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
              />
              <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
              />
              <form-toggle
                grid="12"
                mt="0"
                v-model="outrasAssinaturas"
                label="Outras assinaturas"
              />
            </div>
          </div>
          <div class="row no-print" v-if="item.anexos && item.anexos.length">
            <div class="col-md-12">
              <anexos :anexos="item.anexos" />
            </div>
          </div>
          <div class="row no-print" v-if="item">
            <div class="col-md-12">
              <modulo-comentario module="Atendimento" :id="$route.params.id" />
            </div>
          </div>
        </print-content>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      item: [],
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      servicos: [],
      unidades: [],
      rota_anterior: null,
      outrasAssinaturas: false,
      email: true,
      wpp: true,
    };
  },
  mounted() {
    this.getUnidades();
    this.getServicos();
    this.getItem();
  },
  methods: {
    getItem() {
      axios
        .get(`api/dashboard/atendimentos/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.loading = false;
          this.rota_anterior = this.$route.query.route;
        })
        .catch((error) => {
          this.$router.push("/dashboard/familias");
        });
    },
    getServicos() {
      axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
        this.servicos = response.data;
      });
    },
    getUnidades() {
      axios
        .get(`api/dashboard/unidades/get/externas/PLANTAO`)
        .then((response) => {
          this.unidades = response.data;
        });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
  },
};
</script>
